import { Kbd, TextInput, Flex, Box } from '@mantine/core'
import { useOs } from '@mantine/hooks'
import { openSpotlight } from '@mantine/spotlight'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TbSearch } from 'react-icons/tb'
import classes from './SearchSpotlight.module.css'

export function SearchSpotlight() {
  const { t } = useTranslation()
  const os = useOs()

  const [rightSection, width] = useMemo(
    () =>
      os !== 'ios' && os !== 'android'
        ? [
            <Flex key={os} align="center">
              <Kbd mr={5}>{os === 'macos' ? 'Cmd' : 'Ctrl'}</Kbd>
              <span>+</span>
              <Kbd ml={5}>K</Kbd>
            </Flex>,
            90,
          ]
        : [null, 0],
    [os],
  )

  return (
    <Box className={classes.root}>
      <TextInput
        placeholder={t('generic.search') as string}
        leftSection={<TbSearch size="1rem" />}
        rightSectionWidth={width}
        rightSection={rightSection}
        onClick={openSpotlight}
        onChange={openSpotlight}
        className={classes.control}
        value=""
        styles={{ input: { cursor: 'pointer' } }}
      />
    </Box>
  )
}
